import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';

import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
    background: colors.primaryBackground,
    color: colors.primaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeHeading-4'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
    marginBottom: '8px',
  },
  headerContainer: {
    maxHeight: '64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    padding: '16px 0',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
    width: '100%',
  },
  xMarkIcon: {
    fill: colors.tertiaryIcon,
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    marginTop: '4px',
  },
  inputContainer: {
    paddingTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-24'],
    ':not(#__unused__) input::placeholder': {
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
      color: palette['grey-500'],
    },
    ':not(#__unused__) > div > div:first-child': {
      fontSize: typography['fontSizeCaption-2'],
      lineHeight: typography['lineHeightCaption-2'],
      height: '16px',
      top: '-18px',
      color: palette['grey-700'],
      marginBottom: '2px',
    },
  },
  textareaContainer: {
    marginBottom: '19px',
    ':not(#__unused__) label': {
      fontSize: typography['fontSizeCaption-2'],
      lineHeight: '12px',
      color: palette['grey-700'],
    },
    ':not(#__unused__) > div': {
      margin: '0 !important',
    },
  },
  textCount: {
    position: 'absolute',
    zIndex: -1,
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    right: '25px',
    top: '223px',
  },
  info: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    padding: '6px 0px 14px 0px',
  },
  successInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-16'],
    alignSelf: 'stretch',
  },
  icon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
});
